import { render, staticRenderFns } from "./DZXFNOPN.vue?vue&type=template&id=5f997ca7&scoped=true&"
import script from "./DZXFNOPN.vue?vue&type=script&lang=js&"
export * from "./DZXFNOPN.vue?vue&type=script&lang=js&"
import style0 from "./DZXFNOPN.vue?vue&type=style&index=0&id=5f997ca7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f997ca7",
  null
  
)

export default component.exports